'use strict';

var React = require('react');

var PropTypes = require('prop-types');

module.exports = function render(props) {
  var innerHtml = '<path d="M20.778 2H1.222C.448 2 0 1.552 0 1s.448-1 1.222-1h19.556C21.552 0 22 .448 22 1s-.448 1-1.222 1zm0 8H1.222C.448 10 0 9.552 0 9s.448-1 1.222-1h19.556C21.552 8 22 8.448 22 9s-.448 1-1.222 1zm0 8H1.222C.448 18 0 17.552 0 17s.448-1 1.222-1h19.556c.774 0 1.222.448 1.222 1s-.448 1-1.222 1z" fill="#58595B" fill-rule="evenodd"/><!-- Filename: sourceSvg/menu/hamburger-menu.svg -->';
  var svgProps = {
    className: props.className ? props.className + ' uig-svg-icon' : 'uig-svg-icon',
    dangerouslySetInnerHTML: {
      __html: innerHtml
    },
    viewBox: '0 0 22 18'
  };
  return React.createElement('svg', Object.assign({}, props, svgProps));
};